import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import NumberFormat from 'react-number-format';
import LinearProgress from "@material-ui/core/LinearProgress";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";

const EditBilateralContractView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-8">
                        <TitlePage title="Bilaterales \ Contrato Bilateral \ Editar Contrato"/>
                    </div>
                    <div className="p-col-4">
                        <Button label="Guardar" onClick={props.saveChanges} style={{'float': 'right'}}/>
                        <Button label="Cancelar" className="p-button-secondary"
                                style={{'float': 'right'}}
                                onClick={props.returnBilateralContractPage}/>&nbsp;
                    </div>
                    <div className="p-col-12"><Divider/></div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Institución" isBold={true}/>
                        <SubtitleLabel header={props.dataContract.borrowerName}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Aforo" isBold={true}/>
                        <NumberFormat decimalScale={4}
                                      maxLength={8}
                                      name="haircut"
                                      placeholder="Ex: 99.0000"
                                      value={props.dataContract.haircut}
                                      onChange={props.handleChangeValue}
                                      displayType={props.isClosed ? "input" : "text"}
                                      isNumericString={true}
                                      allowNegative={false}
                        />
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Línea de crédito" isBold={true}/>
                        <NumberFormat thousandSeparator={true}
                                      decimalScale={2}
                                      maxLength={17}
                                      name="threshold"
                                      placeholder="Ex: 9,999.00"
                                      value={props.dataContract.threshold}
                                      onChange={props.handleChangeValue}
                                      isNumericString={true}
                                      displayType= {"input"}
                                      allowNegative={false}
                        />
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-1">&nbsp;</div>
                    <div className="p-col-12 p-md-6 p-lg-3">&nbsp;</div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Línea Utilizada" isBold={true}/>
                        <NumberFormat thousandSeparator={true}
                                      id={11}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      name="usedThreshold"
                                      placeholder="Ex: 9,999.00"
                                      value={props.dataContract.usedThreshold}
                                      onChange={props.handleChangeValue}
                                      displayType={"text"}
                                      prefix={"$"}
                                      isNumericString={true}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Línea disponible" isBold={true}/>
                        <NumberFormat thousandSeparator={true}
                                      id={11}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      name="availableThreshold"
                                      placeholder="Ex: 9,999.00"
                                      value={props.dataContract.availableThreshold}
                                      onChange={props.handleChangeValue}
                                      displayType={"text"}
                                      prefix={"$"}
                                      isNumericString={true}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-1">&nbsp;</div>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(EditBilateralContractView);

EditBilateralContractView.propTypes = {
    dataContract: PropTypes.object.isRequired,
    returnBilateralContractPage: PropTypes.func.isRequired,
    saveChanges: PropTypes.func.isRequired,
    handleChangeValue: PropTypes.func.isRequired,
    messagesGrowl: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    isClosed: PropTypes.bool.isRequired,
}